// This icon file is generated automatically.
var PLeftCircleOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "g", "attrs": { "fill-rule": "nonzero" }, "children": [{ "tag": "path", "attrs": { "d": "M8.43 4.12L4.58 6.9a.12.12 0 000 .2l3.85 2.78c.08.06.2 0 .2-.1v-.73a.5.5 0 00-.21-.4L6.15 7l2.27-1.64a.5.5 0 00.2-.4v-.74c0-.1-.11-.16-.2-.1z" } }, { "tag": "path", "attrs": { "d": "M7 0a7 7 0 100 14A7 7 0 007 0zm0 12.81A5.81 5.81 0 117 1.2 5.81 5.81 0 017 12.8z" } }] }] }, "name": "p-left-circle", "theme": "outlined" };
export default PLeftCircleOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PLeftCircleOutlined.js
// module id = 3476
// module chunks = 0